module.exports = __webpack_public_path__ + "static/media/26UNRWA18.ee1b6acf.jpg";